import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-submit",
  "use": "icon-submit-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-submit\">\r\n  <path d=\"M913.536524 551.447587H116.910163c-23.637854 0-42.977915-19.340062-42.977916-42.977916s19.340062-42.977915 42.977916-42.977915h796.626361c23.637854 0 42.977915 19.340062 42.977916 42.977915s-19.340062 42.977915-42.977916 42.977916z\" p-id=\"1008\" />\r\n  <path d=\"M472.194264 906.731688V110.105326c0-23.637854 19.340062-42.977915 42.977915-42.977915s42.977915 19.340062 42.977916 42.977915v796.626362c0 23.637854-19.340062 42.977915-42.977916 42.977915s-42.977915-19.340062-42.977915-42.977915z\" p-id=\"1009\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/submit.svg
// module id = 6yke
// module chunks = 14